$(function () {

  // 1桁のときに 0 を付ける関数
  function zeroPad(num) {
    return num < 10 ? '0' + num : num;
  }

  $('.campaign .slide01')
    .on('init', function (event, slick) {
      $(this).append(
        '<div class="slick-num">' +
          '<span class="now-count"></span>／<span class="all-count"></span>' +
        '</div>'
      );

      $('.now-count').text(zeroPad(slick.currentSlide + 1));
      $('.all-count').text(zeroPad(slick.slideCount));
    })
    .slick({
      speed: 1000,
      arrows: true,
      dots: false,
      slidesToShow: true,
      centerMode: true,
      variableWidth: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false
    })
    .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      $('.now-count').text(zeroPad(nextSlide + 1));
    });
    
    
    $('.nayami .slide02').slick({
      speed: 1000,
      arrows: true,
      dots: true,
      variableWidth: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false
    })
    
    $('.product .slide03').slick({
      speed: 1000,
      arrows: true,
      dots: true,
      variableWidth: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false
    })
    
    $('.voice .slide05').slick({
      speed: 1000,
      arrows: true,
      dots: false,
      variableWidth: true,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false
    })

});
